export const SAVE_OCR = "box/SAVE_OCR";
export const SAVE_OCR_SUCCESS = "box/SAVE_OCR_SUCCESS";
export const SAVE_OCR_ERROR = "box/SAVE_OCR_ERROR";

export const UPDATE_OCR = "box/UPDATE_OCR";
export const UPDATE_OCR_SUCCESS = "box/UPDATE_OCR_SUCCESS";
export const UPDATE_OCR_ERROR = "box/UPDATE_OCR_ERROR";
